const { API } = require("./api/shopifyApi")

const SHOPIFY_API = new API();

const addToCart = SHOPIFY_API.addToCart;
const updateCart = SHOPIFY_API.updateCart;
const renderShopifySection = SHOPIFY_API.renderShopifySection;
const shopifySectionByUrl = SHOPIFY_API.shopifySectionByUrl;
const shopifyVariantByUrl = SHOPIFY_API.shopifyVariantByUrl;
const getRecommendedProducts = SHOPIFY_API.getRecommendedProducts;
const read = SHOPIFY_API.read;
const recommendationByApi = SHOPIFY_API.recommendationByApiM;
const changeCart = SHOPIFY_API.changeCart;

module.exports = {
  addToCart,
  updateCart,
  renderShopifySection,
  shopifySectionByUrl,
  shopifyVariantByUrl,
  getRecommendedProducts,
  read,
  recommendationByApi,
  changeCart
}